import React from "react";

import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
export default function AdjustmentFormRow({
  item,
  index,
  handleAdjustmentFrom,
  adjustmentValidation,
  disabled,
  promoterOptions,
  productOptions,
  removeAdjustmentFromData,
}) {
  const adjustmentFormRow = React.useMemo(
    () => (
      <Stack key={index} sx={{ my: 2 }} direction={"row"} spacing={2}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems={"flex-start"}
          sx={{ flex: 7 }}
          spacing={1}
        >
          <Autocomplete
            sx={{ flex: 1 }}
            required
            id="combo-box-demo"
            options={promoterOptions}
            value={item.adjustUser}
            onChange={async (e, newValue) => {
              handleAdjustmentFrom(index, "adjustUser", newValue);
            }}
            label="員工"
            renderInput={(params) => <TextField {...params} label="員工" />}
          />
          <ProductAutoComplete
            multiple
            disabled={disabled}
            sx={{ flex: 1, width: 200 }}
            productOptions={productOptions}
            handleOnChange={(value) => {
              handleAdjustmentFrom(index, "productIds", value);
            }}
            selectedValue={item.productIds ?? []}
            error={!!adjustmentValidation[index]?.productIdsErr}
          ></ProductAutoComplete>
          <TextField
            disabled={disabled}
            error={!!adjustmentValidation[index]?.adjustAmountErr}
            helperText={adjustmentValidation[index]?.adjustAmountErr}
            sx={{ flex: 0.7 }}
            value={item.adjustAmount}
            type="number"
            id="outlined-basic"
            label="調整金額"
            variant="outlined"
            onChange={(event) =>
              handleAdjustmentFrom(index, "adjustAmount", event.target.value)
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          <TextField
            value={item.remark}
            sx={{ flex: 1 }}
            id="outlined-basic"
            error={!!adjustmentValidation[index]?.remarkErr}
            helperText={adjustmentValidation[index]?.remarkErr}
            label="備註"
            onChange={(event) =>
              handleAdjustmentFrom(index, "remark", event.target.value)
            }
            variant="outlined"
          />
        </Stack>
        {!disabled && (
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems={"flex-start"}
            sx={{ flex: 1 }}
          >
            <IconButton
              color="error"
              onClick={() => removeAdjustmentFromData(index)}
            >
              <DeleteForeverIcon></DeleteForeverIcon>
            </IconButton>
          </Stack>
        )}
      </Stack>
    ),
    [item, index, removeAdjustmentFromData]
  );
  return adjustmentFormRow;
}
